import { DirectionalLight, Mesh, ShadowGenerator, Vector3 } from "babylonjs";

import VueStore from "@/store";
import store from "./store";

let shadowGenerator: ShadowGenerator;

function create() {
  const shadowLight = new DirectionalLight(
    "shadowLight",
    Vector3.Zero(),
    store.scene
  );

  shadowLight.intensity = 1;
  shadowLight.position = new Vector3(-5, 10, -5);
  shadowLight.setDirectionToTarget(Vector3.Zero());

  // Shadows
  if (!VueStore.state.isMobile) {
    shadowGenerator = new ShadowGenerator(1024, shadowLight);

    shadowGenerator.filter = ShadowGenerator.FILTER_PCSS;
    shadowGenerator.filteringQuality = ShadowGenerator.QUALITY_MEDIUM;
    shadowGenerator.bias = 0.01;
    shadowGenerator.setDarkness(0);
  } else {
    shadowGenerator = new ShadowGenerator(512, shadowLight);
    // shadowGenerator.filter = ShadowGenerator.FILTER_NONE;
    shadowGenerator.filter = ShadowGenerator.FILTER_POISSONSAMPLING;
    shadowGenerator.bias = 0.001;
    shadowGenerator.setDarkness(0.4);
  }

  shadowLight.shadowMinZ = 0;
  shadowLight.shadowMaxZ = 40;
}

function addShadowCaster(obj: Mesh) {
  shadowGenerator.addShadowCaster(obj);
}

export { create, addShadowCaster };
